// components
import { Icon } from '@sdb/planning-ui';
import {
  StyledActionTooltipBox,
  StyledActionTooltipChildrenBox,
  StyledActionTooltipCloseIconButton,
  StyledActionTooltipContentBox,
  StyledActionTooltipTypography
} from './ActionTooltip.styles';

// types
import { TooltipRecurringProps } from './ActionTooltipBody.types';

export default function TooltipRecurring({
  children,
  title,
  onClose
}: TooltipRecurringProps) {
  return (
    <StyledActionTooltipBox>
      <StyledActionTooltipCloseIconButton
        aria-label="close"
        onClick={onClose}
        size="small"
      >
        <Icon type="xmark" fontSize="small" />
      </StyledActionTooltipCloseIconButton>
      <StyledActionTooltipContentBox>
        <StyledActionTooltipTypography variant="body1">
          {title}
        </StyledActionTooltipTypography>
        <StyledActionTooltipChildrenBox>
          {children}
        </StyledActionTooltipChildrenBox>
      </StyledActionTooltipContentBox>
    </StyledActionTooltipBox>
  );
}
